import { render, staticRenderFns } from "./infoOtherRestaurantsAddNewData.vue?vue&type=template&id=042670cc&scoped=true"
import script from "./infoOtherRestaurantsAddNewData.vue?vue&type=script&lang=js"
export * from "./infoOtherRestaurantsAddNewData.vue?vue&type=script&lang=js"
import style0 from "./infoOtherRestaurantsAddNewData.vue?vue&type=style&index=0&id=042670cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042670cc",
  null
  
)

export default component.exports